<template>
  <div class="skeleton-loader">
    <!-- Card skeleton -->
    <v-card v-if="type === 'card'" class="skeleton-card">
      <v-skeleton-loader
        type="card-avatar, article, actions"
        :loading="true"
        transition="fade-transition"
      ></v-skeleton-loader>
    </v-card>

    <!-- Table skeleton -->
    <v-skeleton-loader
      v-else-if="type === 'table'"
      type="table"
      :loading="true"
      transition="fade-transition"
    ></v-skeleton-loader>

    <!-- List skeleton -->
    <div v-else-if="type === 'list'">
      <v-skeleton-loader
        v-for="i in rows"
        :key="i"
        type="list-item-avatar-two-line"
        :loading="true"
        transition="fade-transition"
        class="mb-3"
      ></v-skeleton-loader>
    </div>

    <!-- Custom dashboard skeleton -->
    <div v-else-if="type === 'dashboard'">
      <v-row>
        <v-col cols="12" md="3" v-for="i in 4" :key="i">
          <v-skeleton-loader
            type="card"
            :loading="true"
            height="120"
            transition="fade-transition"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row class="mt-4">
        <v-col cols="12" md="8">
          <v-skeleton-loader
            type="article, table"
            :loading="true"
            transition="fade-transition"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="4">
          <v-skeleton-loader
            type="card, list-item@3"
            :loading="true"
            transition="fade-transition"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </div>

    <!-- Competition cards skeleton -->
    <div v-else-if="type === 'competitions'" class="competitions-skeleton">
      <div class="d-flex gap-4">
        <v-card v-for="i in 3" :key="i" class="competition-skeleton-card">
          <v-skeleton-loader
            type="article, divider, list-item-three-line, actions"
            :loading="true"
            transition="fade-transition"
          ></v-skeleton-loader>
        </v-card>
      </div>
    </div>

    <!-- Default skeleton -->
    <v-skeleton-loader
      v-else
      :type="type"
      :loading="true"
      transition="fade-transition"
    ></v-skeleton-loader>
  </div>
</template>

<script>
export default {
  name: 'SkeletonLoader',
  props: {
    type: {
      type: String,
      default: 'card'
    },
    rows: {
      type: Number,
      default: 3
    }
  }
}
</script>

<style lang="scss" scoped>
.skeleton-loader {
  .skeleton-card {
    background: transparent;
  }

  .competition-skeleton-card {
    max-width: 400px;
    flex: 0 0 400px;
  }

  .competitions-skeleton {
    overflow: hidden;
  }
}

// Add shimmer effect
::v-deep .v-skeleton-loader__bone {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.theme--dark {
  ::v-deep .v-skeleton-loader__bone {
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.1) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
  }
}
</style>